import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemindersV2Component } from './reminders-v2.component';
import { NbButtonModule, NbCardModule, NbIconModule, NbAccordionModule } from '@nebular/theme';
import { FlexLayoutModule } from '@angular/flex-layout';
const component = RemindersV2Component



@NgModule({
  declarations: [component],
  imports: [
    CommonModule,
    NbIconModule,
    NbCardModule,
    FlexLayoutModule,
    NbButtonModule,
    NbAccordionModule
  ],
   exports: [component]
})
export class RemindersV2Module { }
